import { ActionType, createAsyncAction } from 'typesafe-actions'
import { GrunndataResult } from '../../api'

export const grunndataActions = createAsyncAction(
  'grunndata/FETCH_REQUEST',
  'grunndata/FETCH_SUCCESS',
  'grunndata/FETCH_FAILURE'
)<void, GrunndataResult, Error>()

export function fetchGrunndata() {
  return async (dispatch, getState, api) => {
    await dispatch(grunndataActions.request())
    return api
      .getGrunndata()
      .then(grunndata => {
        return dispatch(grunndataActions.success(grunndata))
      })
      .catch(e => {
        return dispatch(grunndataActions.failure(e))
      })
  }
}

export type GrunndataAction = ActionType<typeof grunndataActions>
